import { clientsReducer } from './clients.reducer'
export * from './clients.thunks'
export * from './clients.actions'

export default clientsReducer
